import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ClickAwayListener from 'react-click-away-listener'
import { Localized } from '@fluent/react'

import { Button } from '@mote/ui'

export const InfoModal = ({ isVisible, onClose }) => {
  if (!isVisible) return null

  return (
    <ClickAwayListener onClickAway={onClose}>
      <Root>
        <Content>
          <Localized id='lp--slowly-translating-text-notification'>
            We are slowly translating our website and chrome extension, please
            give us some time!
          </Localized>
          <ButtonWrapper>
            <Button size='sm' text='OK' onClick={() => onClose()} />
          </ButtonWrapper>
        </Content>
      </Root>
    </ClickAwayListener>
  )
}

const Root = styled.div`
  position: absolute;
  font-size: 14px;
  line-height: 20px;
  bottom: 95px;
  right: 0;
`

const Content = styled.div`
  position: relative;
  z-index: 20;
  display: flex;
  flex-direction: column;
  height: 160px;
  background-color: rgba(255, 255, 255, 1);
  border-width: 1px;
  border-color: rgba(228, 228, 231, 1);
  border-radius: 6px;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  width: 240px;
  padding: 16px;
  color: #232323;
`

const ButtonWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  align-self: center;
`

InfoModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired
}
